import http from '@/http'

const API_PATH = 'contact/issues'

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async create({ commit }, payload) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    const params = JSON.stringify({
      issue: payload
    })
    await http({
      url: tmpURL + API_PATH,
      method : 'POST',
      data: params
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
